/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Auth0Config,
  Auth0Config$inboundSchema,
  Auth0Config$Outbound,
  Auth0Config$outboundSchema,
} from "./auth0config.js";
import {
  BuildConfig,
  BuildConfig$inboundSchema,
  BuildConfig$Outbound,
  BuildConfig$outboundSchema,
} from "./buildconfig.js";
import {
  DeploymentConfig,
  DeploymentConfig$inboundSchema,
  DeploymentConfig$Outbound,
  DeploymentConfig$outboundSchema,
} from "./deploymentconfig.js";
import {
  LaunchDarklyConfig,
  LaunchDarklyConfig$inboundSchema,
  LaunchDarklyConfig$Outbound,
  LaunchDarklyConfig$outboundSchema,
} from "./launchdarklyconfig.js";
import {
  PreauthenticationConfig,
  PreauthenticationConfig$inboundSchema,
  PreauthenticationConfig$Outbound,
  PreauthenticationConfig$outboundSchema,
} from "./preauthenticationconfig.js";

export type ApplicationConfig = {
  /**
   * Information for connecting to our authentication provider
   */
  auth0?: Auth0Config | undefined;
  /**
   * Information about the software version that is deployed
   */
  build: BuildConfig;
  /**
   * Information about the environment that the software is deployed to
   */
  deployment: DeploymentConfig;
  /**
   * Information about our feature flag provider
   */
  launchDarkly: LaunchDarklyConfig;
  /**
   * Indication that the Gaia session is pre-authenticated via AgentProxy Mode (aka Local Online Mode).
   */
  preauthentication?: PreauthenticationConfig | undefined;
};

/** @internal */
export const ApplicationConfig$inboundSchema: z.ZodType<
  ApplicationConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  auth0: types.optional(Auth0Config$inboundSchema),
  build: BuildConfig$inboundSchema,
  deployment: DeploymentConfig$inboundSchema,
  launch_darkly: LaunchDarklyConfig$inboundSchema,
  preauthentication: types.optional(PreauthenticationConfig$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "launch_darkly": "launchDarkly",
  });
});
/** @internal */
export type ApplicationConfig$Outbound = {
  auth0?: Auth0Config$Outbound | undefined;
  build: BuildConfig$Outbound;
  deployment: DeploymentConfig$Outbound;
  launch_darkly: LaunchDarklyConfig$Outbound;
  preauthentication?: PreauthenticationConfig$Outbound | undefined;
};

/** @internal */
export const ApplicationConfig$outboundSchema: z.ZodType<
  ApplicationConfig$Outbound,
  z.ZodTypeDef,
  ApplicationConfig
> = z.object({
  auth0: Auth0Config$outboundSchema.optional(),
  build: BuildConfig$outboundSchema,
  deployment: DeploymentConfig$outboundSchema,
  launchDarkly: LaunchDarklyConfig$outboundSchema,
  preauthentication: PreauthenticationConfig$outboundSchema.optional(),
}).transform((v) => {
  return remap$(v, {
    launchDarkly: "launch_darkly",
  });
});

export function applicationConfigToJSON(
  applicationConfig: ApplicationConfig,
): string {
  return JSON.stringify(
    ApplicationConfig$outboundSchema.parse(applicationConfig),
  );
}
export function applicationConfigFromJSON(
  jsonString: string,
): SafeParseResult<ApplicationConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApplicationConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApplicationConfig' from JSON`,
  );
}
